import React from 'react';

export default function CoolingTower1Icon({
  width = 64,
  height = 77,
  startColor = '#4C4C4C',
  midColor = '#F0E8E1',
  endColor = '#4C4C4C'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 93.787 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Cooling_Tower">
	<path fill="none" stroke="#CCB299" strokeWidth="0.25" d="M93.787,109.399L72.841,37.309V27.81l2.367-23.408H18.959l2.367,23.408   v9.499L0.38,109.787" />
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="18.7124" y1="4.7695" x2="74.9619" y2="4.7695">
		<stop offset="0" style={{stopColor: "#D6C2AD"}} />
		<stop offset="0.5" style={{stopColor: "#F0E8E1"}} />
		<stop offset="1" style={{stopColor: "#D6C2AD"}} />
	</linearGradient>
	<ellipse fill={`url(#${id}_1_)`} stroke="#CCB299" strokeWidth="0.25" cx="46.837" cy="4.77" rx="28.125" ry="4.73" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="0" y1="109.8477" x2="93.7871" y2="109.8477">
		<stop offset="0" style={{stopColor: "#D6C2AD"}} />
		<stop offset="0.28" style={{stopColor: "#DBC9B7"}} />
		<stop offset="0.5" style={{stopColor: "#F0E8E1"}} />
		<stop offset="0.73" style={{stopColor: "#D9C6B2"}} />
		<stop offset="1" style={{stopColor: "#D6C2AD"}} />
	</linearGradient>
	<ellipse fill={`url(#${id}_2_)`} stroke="#4C4C4C" strokeWidth="0.2" cx="46.894" cy="109.85" rx="46.894" ry="2.375" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="0.3794" y1="57.0938" x2="93.7871" y2="57.0938">
		<stop offset="0" style={{stopColor: "#D6C2AD"}} />
		<stop offset="0.28" style={{stopColor: "#DBC9B7"}} />
		<stop offset="0.5" style={{stopColor: "#F0E8E1"}} />
		<stop offset="0.73" style={{stopColor: "#D9C6B2"}} />
		<stop offset="1" style={{stopColor: "#D6C2AD"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M93.787,109.399L72.841,37.309V27.81l2.367-23.408H18.959l2.367,23.408v9.499L0.379,109.787" />
</g>
<g id="Group_Lines">
	<path fill="none" stroke="#CCB299" strokeWidth="0.5" d="M73.271,111.936L60.984,37.538v-9.469l1.69-26.941" />
	<path fill="none" stroke="#CCB299" strokeWidth="0.5" d="M46.894,0v112.5" />
	<path fill="none" stroke="#CCB299" strokeWidth="0.5" d="M20.516,111.936L32.69,37.538v-9.469L31,1.127" />
</g>
    
      </g>
      <rect x="0" y="0" width="93.787" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
